import type { Prediction } from "@buildlab/shared/steps";
import { Narrate } from "./Narrate";
import "./guide.css";

// Predict before play (Review 17, D47; PRIMM's "Predict"): in lessons that start from a program the
// student was given, the game waits behind a Press Play cover with one question. Tapping an answer
// saves it (the teacher sees it on Submissions; nothing is graded) and starts the game. Teachers can
// skip it with one click.

export function PredictCover({ predict, assignmentId, onAnswer, teacher, onSkip }: { predict: Prediction; assignmentId: string; onAnswer: (choice: string) => void; teacher: boolean; onSkip: () => void }) {
  return (
    <div className="predict-cover" role="group" aria-labelledby="predict-q">
      <span className="predict-kicker">Press play</span>
      <p className="predict-hint">Before you play, make a guess.</p>
      <h3 id="predict-q" className="predict-q">
        {predict.question}
      </h3>
      <Narrate text={predict.question} clip={`${assignmentId}/predict`} label="Read the question aloud" />
      <div className="predict-choices">
        {predict.choices.map((c, i) => (
          <button key={c} type="button" className="predict-choice" onClick={() => onAnswer(c)}>
            <span className="predict-letter" aria-hidden="true">
              {"ABC"[i] ?? i + 1}
            </span>
            {c}
          </button>
        ))}
      </div>
      <p className="predict-note">Any answer is fine. Then the game starts, and you find out.</p>
      {teacher && (
        <button type="button" className="linklike small predict-skip" onClick={onSkip}>
          Skip (teacher)
        </button>
      )}
    </div>
  );
}
